<template>
  <div>
    <b-row>
      <b-col cols="2">
        <BfInput
          label="Clave"
          data-key="clave"
          :value="data.clave"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" md="4">
        <BfInput
          label="Nombre"
          data-key="nombre"
          :value="data.nombre"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
        />
      </b-col>
    </b-row>
     <b-row>
      <b-col sm="6" md="4">
        <BfInput
          label="Email"
          data-key="email"
          :edit-mode="editing"
          :value="data.user.email"
          :errors="errors"
          @update="updateForm"
        />
      </b-col>
    </b-row>
     <b-row>
      <b-col sm="6" md="4">
        <BfButton
        v-if="editing"
        @click="showModal"
          variant="orange"
>
          Cambiar contraseña
        </BfButton>
         <BfInput
         v-else
          label="Contraseña"
          data-key="password"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
          type="password"
        />
      </b-col>
     <!--  <b-col sm="6" md="4">
        <BfInput
          label="Confirmación de contraseña"
          data-key="password_confirmation"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
          type="password"
        />
      </b-col>  -->
    </b-row>
    <b-row>
      <b-col sm="6" md="4">
        <BfSelect
          label="Rol"
          data-key="rol"
          :value="data.user.user_roles[0]"
          :options="rolOptions"
          :edit-mode="editing"
          :errors="errors"
          :bottom-gutter="false"
          @update="updateForm"
        />
      </b-col>
     <!-- <b-col sm="6" md="4">
        <BfButton
          v-if="editing"
          variant="red"
          @click="desvincularUsuario"
          style="margin-top:2em;"
        >
        Desvincular usuario
      </BfButton>
      </b-col> -->
    </b-row>

    <b-row>
      <b-col sm="6" md="4">
        <BfSelect
          label="Zona"
          data-key="zona_id"
          :value="data.zona_nombre"
          :options="zoneOptions"
          :edit-mode="editing"
          :errors="errors"
          :bottom-gutter="false"
          @update="updateForm"
        />
      </b-col>

      <b-col sm="6" md="4">
        <BfButton
          v-if="editing"
          variant="red"
          @click="desvincularZona"
          style="margin-top:2em;"
        >
        Desvincular Zona
      </BfButton>
      </b-col>
    </b-row>

    <BfCheckbox
      label="Activo"
      data-key="activo"
      :value="!!data.activo"
      :edit-mode="editing"
      :bottom-gutter="false"
      @update="updateForm"
    />

    <BfCheckbox
      label="Oficial"
      data-key="oficial"
      :value="!!data.oficial"
      :edit-mode="editing"
      :bottom-gutter="false"
      @update="updateForm"

    />

  </div>


</template>

<script>
import { zoneAPI } from '@/api';

export default {
  name: 'AssessorForm',

  props: {
    data: {
      type: Object,
      default: () => ({
        activo: false,
        clave: '',
        nombre: '',
        oficial: false,
      }),
    },
    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },
  },
  data: () => ({
    zoneData: [],
    userData: [],
    user: [],
    rolData: [],
    rolOptions: [
      {
        label: 'Administrador',
        value: 'admin',
      },
      {
        label: 'Tasador',
        value: 'tasador',
      },
      {
        label: 'Gestor',
        value: 'colaborador',
      },
    ],
  }),
  async created() {
    const {
      data: { data = [] },
    } = await zoneAPI.getAll();
    this.zoneData = data;
  },
  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },

    desvincularZona() {
      this.$emit('desvincularZona');
    },
    showModal() {
      this.$emit('showModal');
    },
  },
  computed: {
    zoneOptions() {
      return this.zoneData
        .filter(({ tasadores_id: id = null }) => id === null)
        .map(({ id, nombre, numero }) => ({
          label: `${nombre} (${numero})`,
          value: id,
        }));
    },
  },
};
</script>
